import makeRequest, { REQUEST_TYPES } from '../../utils/request'

const JwtService = {
    async refreshToken(): Promise<any> {
        return await makeRequest(`/api/v1/token`, REQUEST_TYPES.get)
    },
}

export default JwtService
